import StandardModal from "js/components/shared/StandardModal";
import SupportDetails from "js/components/SupportDetails";
import { getSupportContactDetails } from "stores/classwizeConfigStore";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	open: boolean;
	okay: () => void;
}

export const DistrictSupportWindow: FC<Props> = ({ open, okay }) => {
	const { t } = useTranslation();
	const contactDetails = getSupportContactDetails();

	return (
		<StandardModal title={t("overview.supportDetailsTitle")} open={open} close={okay}>
			{contactDetails ? (
				<>
					<div>{contactDetails.support_message}</div>
					<br />
					<SupportDetails />
				</>
			) : (
				<div>{t("overview.supportNotConfigured")}</div>
			)}
		</StandardModal>
	);
};
